var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlightSmileRobotFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219 204.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c3d8dd;}.cls-2{fill:#d5e8ef;}.cls-3{fill:#f2fafc;}.cls-4{fill:#353849;}.cls-5{fill:#51f2e2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.29,
    y: 19.7,
    width: 8.41,
    height: 32.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.42,99.17H219a0,0,0,0,1,0,0V159a0,0,0,0,1,0,0H203.42a26.4,26.4,0,0,1-26.4-26.4v-7A26.4,26.4,0,0,1,203.42,99.17Z",
    transform: "translate(396.02 258.14) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.4,99.17H42a0,0,0,0,1,0,0V159a0,0,0,0,1,0,0H26.4A26.4,26.4,0,0,1,0,132.57v-7A26.4,26.4,0,0,1,26.4,99.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.75,
    y: 55.1,
    width: 173.5,
    height: 149.62,
    rx: 61.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.75,
    y: 45.63,
    width: 173.5,
    height: 149.62,
    rx: 61.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.13,
    y: 55.98,
    width: 100.74,
    height: 136,
    rx: 40.89,
    transform: "translate(233.48 14.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.4,
    y: 61.99,
    width: 96.2,
    height: 132.49,
    rx: 39.83,
    transform: "translate(237.74 18.74) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 109.5,
    cy: 14,
    r: 14,
    transform: "translate(3.08 43.35) rotate(-22.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78,112.05A8.94,8.94,0,1,0,87,121,8.95,8.95,0,0,0,78,112.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141,112.05a8.94,8.94,0,1,0,8.93,8.94A8.95,8.95,0,0,0,141,112.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.5,155c-7.74,0-14.73-4.11-17.8-10.49a3.31,3.31,0,0,1,6-2.87c2,4.1,6.62,6.74,11.83,6.74s9.86-2.64,11.84-6.74a3.31,3.31,0,1,1,6,2.87C124.23,150.85,117.24,155,109.5,155Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlightSmileRobotFace);
export default __webpack_public_path__ + "static/media/SlightSmileRobotFace.65b734e57467e650e79117e49463faec.svg";
export { ForwardRef as ReactComponent };